<template>
  <div v-if="images.length" class="mt-0 tile tile-images is-ancestor">
    <div v-for="image in images" :key="image.id" class="tile" :class="{
      'is-3': !showImages,
      'is-12': showImages && images.length === 1,
      'is-6': showImages && images.length > 1
      }">
      <div @dragstart="startImageDrag($event, image.id)" :class="[
          'notification',
          showImages ? '' : 'small'
      ]">
        <button class="delete" @click="removeImage(image.id)"></button>
        <img
            class="editor-image"
            :alt="image.name"
             :src="image.thumb_src"
             @click="modalImage = image; showModal = true"
        />
      </div>
    </div>
    <b-modal v-model="showModal" :destroy-on-hide="true">
      <p class="image">
        <img :src="modalImage.src" :alt="modalImage.name">
      </p>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'EditorImages',
  props: {
    tweetIndex: Number,
  },
  data() {
    return {
      showModal: false,
      modalImage: {},
    }
  },
  updated() {
  },
  computed: {
    images() {
      return this.$store.getters.tweetImages(this.tweetIndex)
    },
    showImages() {
      return this.$store.getters.settings('compose', 'viewImages')
    }
  },
  methods: {
    startImageDrag(event, image_id) {
      event.dataTransfer.setData('tweet-index', this.tweetIndex.toString())
      event.dataTransfer.setData('image-id', image_id)
      event.dataTransfer.setDragImage(event.target, 0, 0)
    },
    removeImage(image_id) {
      this.$store.dispatch('removeImageFromTweet', {
        tweet_index: this.tweetIndex,
        image_id: image_id
      })
    },

  }
}
</script>
<style lang="scss" scoped>

.tile-images {
  flex-wrap: wrap;

  .notification {
    border: solid 1px rgba(10, 10, 10, 0.25) !important;
    padding: 0;
    margin: 0;
    max-height: 175px;
    overflow: hidden;

    &.small {
      max-height: 40px;
    }
  }

  .tile {
    cursor: pointer;

    &:hover button.delete {
      background: rgba(10, 10, 10, 1);
      opacity: 0.8;
    }
  }
}

/* unfortunately hard-coded in to `active` and an A tag so we have to manually use this (see dropdown_item.js.flow L40) */
li.dropdown-item a {
  color: #4a4a4a;
}


</style>
